
    // THIS FILE IS AUTO-GENERATED via 'yarn build-trans' !!

    export default {
        locale: 'pl_PL',
        messages: {
			"graphical_template": "Szablon graficzny",
			"fill": "Pożywny",
			"none": "Brak",
			"shape_color": "Kolor wypełnienia",
			"shape_position": "Lokalizacja",
			"shape_size": "Rozmiar",
			"triangle": "Trójkąt",
			"square": "Kwadrat",
			"square_format": "Kwadratowy",
			"wide": "Krajobraz",
			"width": "Szerokość",
			"stroke_width": "Szerokość krawędzi",
			"stroke_color": "Kolor krawędzi",
			"text_stroke_width": "Szerokość obrysu tekstu",
			"text_stroke_color": "Kolor obrysu tekstu",
			"frame_image": "Wykadruj zdjęcie",
			"color": "Kolor",
			"side": "Strona",
			"text": "Tekst",
			"text_color": "Kolor tekstu",
			"text_fontsize": "Wielość tekstu",
			"text_font": "Czcionka",
			"triangle_orientation": "Orientacja trójkąta",
			"search": "Szukaj",
			"up": "Góra",
			"down": "Dół",
			"show_frame": "Pokaż ramkę",
			"dashed": "Przerywana",
			"frame_color": "Kolor ramki",
			"frame_width": "Szerokość ramki",
			"frame_width_placeholder": "Szerokość ramki w pixelach",
			"show_stripe": "Pokaż pasek",
			"stripe_color": "Kolor paska",
			"stripe_position": "Lokalizacja paska",
			"horizontal": "Poziomy pasek",
			"vertical": "Pionowy pasek",
			"stripe_text_placeholder": "Pasek tekstu",
			"shape_text_placeholder": "Tekst w kształcie",
			"text_size_placeholder": "Wielkość tekstu",
			"text_font_placeholder": "Czcionka",
			"nav_queries": "Produkty",
			"nav_size": "Format",
			"nav_frame": "Ramka",
			"nav_filter": "Filtr",
			"nav_stripe": "Pasek",
			"nav_shape": "Warstwa",
			"nav_image": "Obraz",
			"nav_save": "Zapisz",
			"nav_shapes": "Warstwy",
			"upscale_image": "Ulepszenia rozdzielczości",
			"template_type_null": "Szablon graficzny",
			"template_type_1": "Ulepszenia rozdzielczości",
			"template_type_2": "Usuń tło",
			"template_type_3": "Usuń znaki wodne",
			"template_type_4": "Outpainting",
			"template_type_5": "Animowany GIF",
			"template_type_6": "Inpainting",
			"template_type_10": "Obraz z usuniętym znakiem wodnym",
			"template_type_11": "Obraz z usuniętym tłem",
			"template_type_1_started": "Trwa ulepszanie obrazu",
			"template_type_2_started": "Trwa usuwanie tła",
			"template_type_3_started": "Trwa usuwanie znaku wodnego",
			"template_type_4_started": "Trwa malowanie",
			"template_type_6_started": "Malowanie w toku",
			"template_type_1_done": "Poprawiony obraz",
			"template_type_2_done": "Usunięto tło obrazu",
			"template_type_3_done": "Usunięto znak wodny",
			"template_type_4_done": "Malowanie zewnętrzne wykonane",
			"template_type_6_done": "Maľba hotov",
			"outpainting_error": "Błąd malowania",
			"outpaint_over": "Przemalowanie na całym płótnie",
			"upscale_previews_all_done": "Miniatury zostały wygenerowane. W przypadku rozszerzeń rozdzielczości zbiorczej wybierz produkty, do których chcesz zastosować ulepszenia w prawym oknie. Pamiętaj, aby nazwać i zapisać szablon.",
			"min_detection_accuracy": "minimalna dokładność wykrywania",
			"min_detection_accuracy_info": "jeśli dokładność wykrywania jest niższa, oryginalny obraz ze znakiem wodnym zostanie zachowany",
			"get_previews": "Generować podglądy",
			"select_images_for_upscale_previews": "Wybierz obrazki z których chcesz utworzyć podglądy poprawy rozdzielczości.",
			"creating_upscale_previews": "Generowane są podglądy obrazów. Ta operacja jest czasochłonna, może chwilę potrwać. ",
			"sending_images_for_upscale_previews": "Przesyłanie obrazy",
			"original_image": "Oryginalny obrazek",
			"other_images": "Inne obrazy",
			"bgremoved_image": "Edytowany obraz z usuniętym tłem",
			"bgremoved_edited_image": "Obraz z usuniętym tłem",
			"wmremoved_image": "Obraz z usuniętym znakiem wodnym",
			"upscaled_image": "Ulepszony obrazek",
			"no_images_for_upscale": "W Twoim feedzie nie znaleźliśmy żadnych obrazków w rozmiarze do do 600 x 600 pikseli. Nie ma potrzeby poprawiania rozdzielczości.",
			"upscale_template": "Popraw rozdzielczość obrazu",
			"upscale_how_does_it_work": "<h3>Jak to działa</h3><p>....</p>",
			"upscale_method_preview": "Przykłady ulepszeń rozdzielczości",
			"image_is_upscaled": "Obraz o ulepszonej rozdzielczości",
			"show_larger_preview": "Zobacz większy podgląd",
			"upscale_loading_products": "Analizujemy wymiary obrazów w Twoim feedzie. Poprawa rozdzielczości ma sens tylko w przypadku obrazów do 600 x 600 pikseli.",
			"upscale_clear_interval": "Anuluj czynność i wybierz inne obrazy",
			"clear_selection": "Anuluj wybór",
			"selected_count": "Wybrano",
			"cancel": "Anuluj",
			"position": "Pozycja",
			"opacity": "Przejrzystość",
			"apply_on_queries": "Zastosuj do produktów",
			"template_name": "Nazwa szablonu",
			"template_type": "Typ",
			"save_template": "Zapisz szablon",
			"show_shape": "Pokaż warstwę",
			"stroke_opacity": "Przezroczystość krawędzi",
			"priority": "Priorytet",
			"template_list": "Lista szablonów",
			"products": "Produkty",
			"images": "Zdjęcia",
			"count_images": "liczba obrazów",
			"validations": "Sprawdzanie poprawności obrazu",
			"new_template": "Nowy szablon",
			"new_upscale_template": "Popraw rozdzielczość obrazu",
			"new_bgremove_template": "Usuwanie tła",
			"new_wmremove_template": "Usuwanie znaku wodnego",
			"template_gallery": "Galeria szablonów",
			"blank_template": "Pusty szablon",
			"background_color": "Kolor tła",
			"text_background_color": "Kolor tła",
			"background_width": "Szerokość",
			"background_height": "Wysokość",
			"background_type": "Typ tła",
			"background_type_none": "Brak",
			"background_type_circle": "Koło",
			"background_type_rectangle": "Prostokąt",
			"background_type_rectangle-each-line": "Prostokąt na każdą linię",
			"background_type_ellipse": "Elipsa",
			"background_type_image": "Obraz",
			"random_product": "Losowy produkt",
			"stroke": "Krawędź",
			"full": "Pełny",
			"no_templates": "Nie masz jeszcze żadnych szablonów. Stwórz pierwszy!",
			"no_alternative_templates": "Nie masz jeszcze żadnych alternatywnych szablonów.",
			"all_products": "Wszystkie produkty",
			"back": "Wróć",
			"back_to_template_list": "Powrót do listy szablonów",
			"due_date": "Termin",
			"created_at": "Utworzono",
			"save": "Zapisz",
			"save_and_exit": "Zapisz i wyjdź",
			"save_and_apply": "Zapisz i użyj",
			"save_as_new_template": "Zapisz jako nowy szablon",
			"apply": "Zastosować",
			"saving": "jest zapisywany",
			"no_shape_selected": "Nie wybrano warstwy.",
			"user": "Użytkownik",
			"delete": "Usuń",
			"insert": "Wstawić",
			"preview": "Podgląd",
			"pause": "Pauza",
			"start": "Uruchom",
			"action": "Działanie",
			"edit": "Edytuj",
			"next": "Następne",
			"previous": "Poprzednie",
			"project": "Export",
			"eshop": "E-shop",
			"agency": "Agencja",
			"freelancer": "Freelancer",
			"title": "Tytuł",
			"date": "Data",
			"created_by": "Stworzył",
			"max_length": "Maksymalna długość: 1000 znaków",
			"chars_left": "Pozostałe znaki",
			"monday": "Poniedziałek",
			"tuesday": "Wtorek",
			"wednesday": "Środa",
			"thursday": "Czwartek",
			"friday": "Piątek",
			"saturday": "Sobota",
			"sunday": "Niedziela",
			"mon": "Pon",
			"tue": "Wt",
			"wed": "Śr",
			"thu": "Czw",
			"fri": "Pt",
			"sat": "So",
			"sun": "Nd",
			"yes": "Tak",
			"no": "Nie",
			"currency": "PLN",
			"filter": "Filtruj",
			"calcel_filter": "Anuluj filtrowanie",
			"name": "Nazwa",
			"confirm_delete": "Czy na pewno chcesz usunąć ten szablon?",
			"margin": "Margines",
			"add_shape_button": "Nowa warstwa",
			"add_shape": "Dodaj nową warstwę",
			"shape_list": "Lista warstw",
			"diameter": "Średnica",
			"active": "Aktywny",
			"active_from": "Aktywny od",
			"active_to": "Aktywny do",
			"inactive": "Nieaktywny",
			"set_active_date": "Aktywność na szablonach",
			"timer": "Timer",
			"invalid_active_date_range": "Nieprawidłowy zakres dat",
			"circle": "Okrąg",
			"frame": "Ramka",
			"rectangle": "Prostokąt",
			"triangle1": "Trójkąt",
			"triangle2": "Trójkąt",
			"triangle_side_length": "Długość boku",
			"corner_radius": "Zaokrąglanie",
			"dynamicText": "Feed element",
			"imageFromElements": "Obraz z elementu",
			"curvedText": "Tekst wzdłuż krzywej",
			"circleText": "Tekst wzdłuż okręgu",
			"textWithElements": "Tekst z elementami",
			"background_settings": "Ustawienia tła",
			"text_wrap": "Zawijanie tekstu",
			"text_overflow": "Przepełnienie tekstu",
			"text_overflow_keep": "pozostawić bez zmian",
			"text_overflow_fontsize": "zmniejsz rozmiar czcionki",
			"text_overflow_layersize": "powiększ warstwę",
			"text_decoration": "Linia",
			"text_decoration_color": "Kolor linii",
			"text_decoration_linethickness": "Grubość linii",
			"text_decoration_lineoverlap": "Linia nakładania się",
			"text_decoration_none": "brak",
			"text_decoration_underline": "strąk",
			"text_decoration_overline": "ponad",
			"text_decoration_linethrough": "przez",
			"text_direction": "Kierunek tekstu",
			"text_align": "Wyrównanie tekstu",
			"text_align_left": "po lewej stronie",
			"text_align_right": "po prawej stronie",
			"text_align_center": "centrum",
			"text_valign": "Wyrównanie w pionie",
			"text_valign_start": "w górę",
			"text_valign_middle": "wyśrodkowany",
			"text_valign_end": "w dół",
			"height": "Wysokość",
			"aspect_size_ratio": "Zachowaj proporcje",
			"dash_length": "Długość linii",
			"dash_density": "Przerwa",
			"dashedFrame": "Przerywana ramka",
			"coordinate_x": "Współrzędne x",
			"coordinate_y": "Współrzędne y",
			"template_saved": "Szablon zapisany",
			"upload_error_unsupported_type": "Niedozwolony format pliku",
			"upload_error_large_file": "Plik jest za duży. Max. rozmiar to 1 MB.",
			"upload_error_image_too_big": "Wymiary obrazu są za duże. Zmień rozmiar obrazu i spróbuj ponownie.",
			"active_templates": "Aktywne szablony",
			"type": "Typ",
			"file_too_big": "Plik jest za duży. Maksymalny rozmiar to 0,5 MB",
			"file": "Plik",
			"bitmap": "Obraz",
			"polygon": "Polygon",
			"bezier": "Krzywa",
			"line": "Linia",
			"line_cap": "Koniec linii",
			"line_join": "Połączenie linii",
			"line_cap_round": "okrągły",
			"line_cap_inherit": "-",
			"line_cap_butt": "płaska krawędź",
			"line_cap_square": "kwadrat",
			"line_join_inherit": "-",
			"line_join_miter": "ostry róg",
			"line_join_round": "okrągły",
			"line_join_bevel": "ścięty narożnik",
			"collage_layouts": "Kolaże",
			"add_layout_button": "Dodaj",
			"save_as_new_collage": "Zapisz jako nowy kolaż",
			"preview_for_format": "Podgląd formatu",
			"no_custom_sets": "Nie masz jeszcze żadnych niestandardowych zestawów obrazów",
			"custom_image_set_add": "Utwórz zestaw obrazów",
			"custom_image_set_remove": "Anuluj zestaw zdjęć",
			"custom_image_set_remove_image": "Usuń obraz z zestawu",
			"custom_image_set_selected_image": "Wybrany obraz",
			"custom_image_set_selected": "Obrazy z zestawu",
			"custom_set_name": "Nazwa zestawu obrazów",
			"custom_image_set_no_set_selected": "Wybierz zestaw",
			"custom_image_set_no_images_yet": "W tym zestawie nie ma jeszcze zdjęć.",
			"custom_image_set_no_image_selected": "Wybierz obraz",
			"custom_image_set_uploaded": "Obraz przesłany do zestawu",
			"custom_image_set_cannot_remove_is_used": "Obraz jest używany w jednym z szablonów! Nie można usunąć.",
			"custom_image_set_cannot_remove_success": "Obraz usunięty.",
			"custom_image_set_deleted_success": "Zestaw został usunięty",
			"custom_image_set_delete_set_is_used": "Nie można usunąć tego zestawu, jest używany w szablonach.",
			"scale": "Wielkość",
			"adjust_size": "Personalizacja rozmiaru produktu",
			"enlarge": "Dopasuj do formatu",
			"no_enlarge_nor_crop": "bez dostosowania",
			"duplicate": "Szablon powielony",
			"horizontal_flip": "Odwróć w poziomie",
			"vertical_flip": "Odwróć w pionie",
			"flip": "Pionowo",
			"flop": "Poziomo",
			"rotation": "Obróć",
			"elements": "Nazwa elementu, z którego należy wstawić treść",
			"xml_element_name": "Nazwa elementu",
			"rating_xml_element": "Element z oceną",
			"rating_count_xml_element": "Element z wieloma ocenami",
			"rating_max_value": "Maksymalna wartość w elemencie ocenianym",
			"rating_hide_empty": "Tylko jeśli wszystkie elementy z kanału są dostępne",
			"rating_min_stars": "Pokaż oceny od",
			"no_rating_yet": "Nikt jeszcze nie ocenił tego produktu",
			"empty_element": "<ELEMENT JEST PUSTY>",
			"imagick_fonts": "Czcionka",
			"imagick_fonts_family": "Filtruj rodzinę czcionek",
			"imagick_fonts_style": "Styl",
			"imagick_fonts_info": "Uwaga: niektóre dynamiczne czcionki tekstowe nie są dostępne w szybkim widoku. Nie mogą być wyświetlane w taki sam sposób, jak wygenerowany obraz. Aby wyświetlić podgląd tekstu w wybranej czcionce, użyj przycisku Podgląd.",
			"render_preview": "Podgląd",
			"rotate_right": "Obróć w prawo",
			"rotate_left": "Obróć w lewo",
			"image_enlargment": "Powiększ obraz",
			"format": "Format",
			"first": "Pierwszy",
			"last": "Ostatni",
			"previews": "Podgląd",
			"more_previews": "Więcej podglądów",
			"edit_template": "Edytuj szablon",
			"no_templates_this_size": "Nie masz jeszcze takich szablonów",
			"all_templates": "Wszystkie szablony",
			"reload_images": "Więcej podglądów",
			"show_unmodified": "Pokaż niezmodyfikowany",
			"show_modified": "Pokaż modyfikowany",
			"help": "Pomoc",
			"manage_templates": "Zarządzaj szablonami",
			"inactive_templates": "Nieaktywne szablony",
			"show_template": "Pokaż szablon",
			"no_image": "Produkt nie ma zdjęcia.",
			"active_templates_only": "Tylko aktywne szablony",
			"unmodified_images": "Nieedytowane obrazy",
			"allow_cache": "Zezwalaj na pamięć podręczną",
			"no_products_in_query": "Wybory dla tego szablonu zawierają produkty. Wyświetla losowe produkty z kanału XML.",
			"size_format": "Rozmiar",
			"add_new": "Dodaj nowy",
			"new": "Nowy",
			"format_name": "Nazwa formatu",
			"select_format": "Wybierz jeden z formatów wyjściowych...",
			"query_is_required": "Musisz wybrać co najmniej jeden wybór produktu",
			"format_name_is_required": "Musisz podać nazwę wymiaru",
			"width_is_required": "Szerokość musi być większa niż 0.",
			"height_is_required": "Wysokość musi być większa niż 0.",
			"bad_file_format": "Niedozwolony format obrazu",
			"name_is_required": "Musisz wypełnić nazwę szablonu",
			"error_loading_image": "Błąd podczas ładowania obrazu",
			"confirm__bulk_delete": "Czy na pewno chcesz usunąć wybrane szablony?",
			"svg_change_colors": "Zmień kolory",
			"apply_color_change": "Zastosuj zmianę koloru",
			"load_image_error": "Nie udało się załadować obrazu.",
			"badge": "Naklejka",
			"badges": "Naklejki",
			"icons": "Ikony",
			"search_badges_or_icons": "Wyszukaj elementy graficzne lub ikony",
			"tags": "Etykiety",
			"emoji": "Emoji",
			"change": "Zmień",
			"summer": "Lato",
			"borders": "Ramki",
			"rating": "Ranking",
			"rating_source": "Źródło oceny",
			"xml_element": "XML element",
			"depots_extension": "Depots extension",
			"depots_not_enabled": "Aby korzystać z Depots jako źródła ocen obrazów, aktywuj tę funkcję bezpłatnie w sklepie <span class=\"link\" onClick=Mergado.openWindow(\"https://store.mergado.com/detail/mergadodepots/#about\")>Mergado Store</span>.",
			"rating_from_element": "Oceny produktów",
			"star_symbol": "Symbol gwiazdy",
			"active_only": "Użyj aktywnego",
			"dynamic_only": "Użyj dynamicznego",
			"autumn": "Jesień",
			"showroom": "Podgląd szablonu",
			"translate": "Przenieś",
			"crop": "Przytnij",
			"image_format": "Wielkość zdjęcia produktu",
			"enlarge_hint": "Rozmiar obrazu produktu zostanie dostosowany tak, aby zawsze wypełniał żądany format (zachowując proporcje)",
			"crop_hint": "Jeśli obraz produktu jest większy niż ustawiony format, system automatycznie go przyciął.",
			"winter": "Boże Narodzenie",
			"vertical_align_center": "Wyśrodkuj w pionie",
			"horizontal_align_center": "Wyśrodkuj w poziomie",
			"enlarge_by": "Dostosowywanie rozmiaru obrazu według",
			"by_width": "Szerokość zdjęcia",
			"by_height": "Wysokość zdjęcia",
			"by_smaller": "mniejszy rozmiar obrazu",
			"by_bigger": "większy rozmiar obrazu",
			"by_fit": "dopasowanie obrazu wyjściowego",
			"max_image_width": "Maksymalna szerokość obrazu (px)",
			"max_image_height": "Maksymalna wysokość obrazu (px)",
			"by_max_size": "Ustaw maksymalny rozmiar (px)",
			"by_overscan": "Ustaw nakładanie (px)",
			"overscan": "Strefa ochronna",
			"overscan_hint": "Tutaj możesz ustawić, o ile pikseli obraz ma zostać zmniejszony w porównaniu do rozmiaru oryginalnego formatu. Można tutaj ustawić wartość dodatnią lub ujemną. Przy wartości dodatniej uzyskujesz kadrowanie oryginalnego obrazu z ustawionym kolorem tła, ujemne powiększenie.",
			"enlarge_by_hint": "„Wybierz rozmiar obrazu produktu, aby dopasować go do formatu. Zawsze zachowuj proporcje dla wszystkich obrazów źródłowych.",
			"enlarge_by_blog_link": "Bardziej szczegółowe wyjaśnienie",
			"error_save_template": "Wystąpił błąd podczas zapisywania szablonu",
			"free-delivery": "Dni darmowej dostawy",
			"black-friday": "BLACK FRIDAY   &   CYBER MONDAY",
			"valentine": "Walentynki",
			"easter": "Wielkanoc",
			"generic": "Uniwersalne szablony",
			"source_image": "Obraz źródłowy",
			"sourceImage": "Obraz źródłowy",
			"edit_shape": "Edycja warstw",
			"new_shape": "Nowa warstwa",
			"modal_close": "Zamknij",
			"done": "Gotowy",
			"general_error": "Błąd",
			"validation_error_fields.queries": "Nie wybrano żadnych produktów.",
			"validation_error_fields.shapes": "Szablon jest pusty.",
			"validation_error_queries": "Nie wybrano żadnych produktów.",
			"validation_error_size.id": "Brakuje ostatecznego formatu obrazu.",
			"validation_error_name": "Błąd nazwy",
			"validation_error_setName": "Brak nazwy zestawu.",
			"validation_error_visual_similarity_templateids": "Wybierz szablony, w których chcesz szukać podobnych produktów.",
			"shape_name": "Nazwa warstwy",
			"shape_badge_set_change": "Zmień zestaw",
			"delete_shape": "Usuń warstwę",
			"edit_done": "OK",
			"loading": "Ładowanie ...",
			"low_contrast": "Niski kontrast",
			"same_image_in_preview": "Ten sam produkt w podglądzie",
			"processed_at": "Data modyfikacji",
			"total_processed": "Pretworzono",
			"with_status_ok": "Bez błędów",
			"with_status_error": "Błednych",
			"without_images": "Bez obrazów",
			"image_link": "Adres obrazu",
			"content_length": "Rozmiar pliku",
			"probability": "Prawdopodobieństwo",
			"showGroup": "Grupa",
			"user_set": "Zestaw użytkownika",
			"status_code": "Kod statusu",
			"error": "Błąd",
			"status_null": "?",
			"status_0_0": "W czasie przetwarzania niedostępny",
			"status_200_0": "W porządku",
			"status_200_null": "W porządku",
			"status_200_1": "Obraz o zerowym rozmiarze",
			"status_200_435": "Brak szablonu",
			"status_200_425": "Too Early",
			"status_200_450": "Nieznany format",
			"status_500_0": "Wewnętrzny błąd serwera",
			"status_503_0": "Serwis niedostępny",
			"status_400_0": "Zła prośba",
			"status_404_0": "Nieznaleziono strony",
			"status_404_null": "Nieznaleziono strony",
			"status_403_0": "Brak dostępu",
			"status_200_420": "Nieznany format",
			"status_429_0": "Zbyt wiele próśb",
			"status_200_465": "Wysokość lub szerokość obrazu przekracza limit",
			"status_too_many_alts": "Wiele alternatywnych zdjęć",
			"status_same_images": "Produkty z tym samym obrazem",
			"status_empty_images": "Brakujące obrazy",
			"status_empty_images_description": "W pliku XML brakuje elementu IMGURL dla Twoich produktów. Produkty nie są sparowane ze zdjęciami lub całkowicie brakuje plików obrazów. W rezultacie nie pojawią się one w twoim sklepie internetowym ani w komparatorach.",
			"status_unavailable_description": "Jiný status než 200",
			"status_unsupported_mime_type_description": "Format pliku, do którego odwołuje się URL, nie jest obsługiwany przez jedną z porównywarek lub nie jest ustandaryzowany. W pierwszym przypadku zdjęcia produktów zostaną odrzucone przez porównywarkę, w drugim nie zostaną wyświetlone w Twoim sklepie internetowym.",
			"status_invalid_url_description": "Zdjęcia produktów mogą zostać odrzucone przez porównywarkę, jeśli adres URL jest za długi lub zawiera niedozwolone znaki takie jak np. spacje.",
			"has_watermark_description": "Wiele systemów reklamowych jak np. Google, nie wyświetla produktów na które naniesiony jest znak wodny. ",
			"status_wrong_placement_description": "Idealnie, produkty na obrazie powinny być wyśrodkowane i w rozmiarze pasującym do jego wielkości. W przeciwnym razie wartość informacji zostanie utracona i będą wyglądać na niespójne.",
			"status_poor_quality_images_description": "Nieostre zdjęcia o kiepskiej jakości mogą zniechęcić potencjalnych klientów. Zaprezentuj swoje produkty w jak najlepszy sposób. ",
			"status_seo_large_file_description": "<h3>Opis rekomendacji:</h3> Rozmiar zdjęć przekracza limit 400 kB. Szkodzi Twojemu sklepowi internetowemu, ponieważ ładowanie zajmuje dużo czasu. Może to prowadzić do zwiększonego wskaźnika rezygnacji. <br/><h3>Szczegóły rozwiązania:</h3> Feed Image Editor zbiorczo kompresuje zbyt duże obrazy, aby zmniejszyć ich rozmiar, aby szybciej ładowały się w Internecie. Więcej przeczytasz w artykule na <span class=\"link\" onClick=Mergado.openWindow(\"https://www.feed-image-editor.com/improve-image-seo-automatic-compression\")>naszym blogu</span>.",
			"status_few_alt_images_description": "<h3>Szczegółowy opis problemu:</h3> todo: without alternative images description",
			"status_transparent_background_description": "Białe tło zdjęć produktów jest niepisanym standardem dla większości porównywarek. Jeśli niektóre z twoich zdjęć mają przezroczyste tło, zostaną odrzucone lub tło automatycznie wypełni się i będzie wyglądać na ziarniste.",
			"status_same_images_description": "Niektóre produkty, np. ten sam t-shirt w różnych rozmiarach, mają takie same obrazy. Niektóre porównywarki cenowe odrzucają takie obrazy, a co za tym idzie nie wyświetlają ich przy pożądanych produktach.",
			"alternative_images_description": "Produkty mogą być odrzucone przez porównywarkę cenową ponieważ istnieje zbyt wiele obrazów alternatywnych.",
			"status_poor_quality_images": "Jakość obrazu",
			"status_seo_large_file": "Rozmiar pliku graficznego pod kątem SEO",
			"status_few_alt_images": "Możliwość dodania alternatywnych zdjęć",
			"status_all": "Wszystkie produkty",
			"status_unavailable": "Niedostępne obrazy",
			"status_invalid_url": "Niewłaściwy adres URL",
			"status_unsupported_mime_type": "Niewłaściwy typ mim",
			"status_wrong_placement": "Wyśrodkowanie produktu",
			"status_transparent_background": "Przezroczyste tło",
			"unsupported_mime_by_engines": "Format nieobsługiwany przez porównywarki cenowe",
			"supports_formats": "obsługuje formaty",
			"with_problems": "z błędami",
			"clear_old_products": "Usuń stare produkty z db",
			"info_is_new": "Brak importowanych produktów. Wydaje się, że nie ma żadnych zasad dotyczących tego projektu",
			"info_no_data": "Żadne produkty nie pasują do ustawionych filtrów.",
			"info_not_processed_yet": "Przetwarzanie i diagnostyka są przeprowadzane regularnie na przestrzeni dnia",
			"info_apply_one_rule": "Jeśli masz wiele szablonów dla tych samych produktów, stosowany jest tylko szablon o najwyższym priorytecie. Możesz wybrać produkty dla każdego szablonu podczas edycji szablonu na karcie Produkty",
			"filter_image_url": "Adres zdjęcia",
			"filter_product_url": "Adres produktu",
			"filter_product_urls": "Adresy produktów",
			"fulltext": "Wyszukiwanie pełnotekstowe",
			"input_list": "Wprowadź wiele adresów oddzielonych przecinkami lub znakami powrotu karetki",
			"more": "Więcej",
			"less": "Mniej",
			"filter_status_code": "Kod statusu",
			"filter_template": "Szablon",
			"filter_from": "Data od",
			"filter_to": "Data do",
			"filter_productname": "Nazwa produktu",
			"filter_productid": "MERGADO id produktu",
			"filter_element": "Element",
			"filter_element_value": "Wartość elementu",
			"filter_value_from": "Od",
			"filter_value_to": "Do",
			"filter_add": "Element",
			"filter_remove": "Anuluj <br/>wszystkie filtry",
			"filter_group": "Grupa",
			"filter_content_type": "Format obrazu",
			"filter_content_length": "Wielkość",
			"custom_filter": "Vlastní filtr",
			"preset_ranges": "Přednastavené rozsahy",
			"filter_mistake_set_by_user": "Status użytkownika",
			"filter_correctness_percentage_offset": "Odległość do krawędzi",
			"filter_has_alpha": "Przezroczyste tło",
			"filter_status_reason": "Powód stanu",
			"filter_status": "Stav",
			"filter_probability": "Prawdopodobieństwo wystąpienia znaku wodnego [%]",
			"filter_user_set_watermark": "Znak wodny na obrazku (użytkownik)",
			"filter_user_set": "Status użytkownika",
			"watermarks": "Znaki wodne",
			"images_quality": "Status jakości",
			"quality_status": "Jakość obrazu",
			"bad_quality_score": "Słaba jakość wyniku",
			"good_quality": "Dobra",
			"bad_quality": "Zła",
			"middle_quality": "Średniej",
			"diagnostics": "Diagnostyka",
			"processed_alt_images": "Przetworzone obrazy alternatywne",
			"processed_images": "Przetworzone obrazy",
			"problems": "Problemy",
			"warnings": "Ostrzeżenia",
			"recommendations": "Rekomendacje",
			"overview": "Przegląd",
			"watermarks_removal": "Usuwanie znaków wodnych",
			"selected_watermark_pattern": "Ten obraz zostanie użyty jako wzór znaku wodnego, którego szukasz",
			"select_watermark_pattern": "Dodaj do wzorów zawierających znak wodny",
			"user_set_objects": "Pozycje znaku wodnego oznaczone przez użytkownika",
			"with_or_without_objects": "Oznaczone znaki wodne",
			"with_objects": "Z zaznaczonymi znakami wodnymi",
			"without_objects": "Bez oznaczonych znaków wodnych",
			"all": "Wszystko",
			"view_mode": "Widok",
			"problems_text": "Następująca ilość  <b>obrazów produktów nie jest wyświetlana</b>, ponieważ wystąpił co najmniej jeden z problemów:",
			"warnings_text": "Dla następującej listy produktów, <b>obrazy nie będą wyświetlane</b>, ponieważ pojawił się co najmniej jeden z problemów:",
			"recommendations_text": "Dla następującej listy produktów, <b>obrazy nie będą wyświetlane</b>, ponieważ pojawił się co najmniej jeden z problemów:",
			"one_product": "produkt",
			"less_than_five_products": "produkty",
			"products_count": "produktów",
			"image_id": "ID obrázku",
			"mistake_set_by_user": "Błąd ustawiony przez użytkownika",
			"correctness_percentage_offset": "Odległość do krawędzi",
			"has_alpha": "Przejrzystość",
			"status_reason": "Powód stanu",
			"status": "Stav",
			"updated_at": "Zaktualizowano",
			"no_alpha": "Nie",
			"with_alpha": "Tak",
			"info_status_suspicious": "Nie można wykryć, czy obraz został celowo umieszczony",
			"vertical_image": "Obraz pionowy",
			"horizontal_image": "Obraz poziomy",
			"image_down": "Rysunek poniżej",
			"image_up": "Obraz powyżej",
			"image_right": "Rysunek po prawej stronie",
			"image_left": "Obraz po lewej stronie",
			"image_in_the_middle": "Obraz w środku",
			"image_could_not_be_read": "Nie można odczytać obrazu",
			"unknown_image_format": "Nieznany format",
			"option_false": "Nie",
			"option_true": "Tak",
			"option_not_set": "Wartość nie ustawiona",
			"mistake_by_user_successfully_changed": "Zmieniono wartość",
			"status_N/A": "Podejrzany",
			"status_ERROR": "Błąd",
			"status_OK": "W porządku",
			"status_NOT_OK": "Nie w porządku",
			"status_NOT_DETECTED": "Niewykryty",
			"importance_HIGH": "Wysoki",
			"importance_MEDIUM": "Średni",
			"importance_SMALL": "Niski",
			"filter_is_active": "Filtr jest aktywny",
			"export_to_csv": "Eksportuj",
			"csv_download_started": "Wytwarzam CSV, proszę czekać",
			"csv_download_success": "Plik został utworzony",
			"csv_download_error": "Wystąpił błąd podczas eksportowania do pliku CSV",
			"shop_link": "Link do e-shopu",
			"unmodified_link": "Nieedytowany obraz",
			"modified_link": "Obraz nad szablonem",
			"total_products": "Produkty",
			"total_images": "Obrazów",
			"total_alt_images": "Alternatywne obrazy",
			"total_products_info": "Łączna ilość produktów importowanych z MERGADY",
			"no_products_yet": "Brak produktów importowanych do tego szablonu.",
			"total_processed_products_info": "Łącznie produkty wstępnie przetworzone",
			"product": "Produkt",
			"product_category": "Kategoria",
			"product_links": "Referencje",
			"eshop_product": "Produkt w e-shopie",
			"barcode_lookup": "Produkt w BarcodeLookup",
			"product_name": "Produkt",
			"product_no": "Numer produktu",
			"product_code": "Kod produktu",
			"product_image": "Zdjęcie",
			"product_template": "Szablon",
			"product_image_link": "Adres zdjęcia",
			"element_item_id": "ID produktu",
			"element_url": "Adres E-shopu",
			"element_cpc": "CPC",
			"element_name": "Nazwa produktu",
			"element_img_url": "Adres obrazu wyjściowego",
			"element_img_url_input": "Adres obrazu wejściowego",
			"element_alt_img_url": "Adres alternatywnego obrazu wyjściowego",
			"element_alt_img_url_input": "Wprowadź alternatywny adres obrazu",
			"element_price_vat": "Cena z VAT",
			"element_delivery_date": "DELIVERY_DATE",
			"element_manufacturer": "Producent",
			"element_categorytext": "Kategoria",
			"element_ean": "EAN",
			"element_productno": "Numer produktu",
			"element_accessory": "Akcesoria",
			"element_gift": "Prezent",
			"element_itemgroup_id": "ITEMGROUP_ID",
			"advanced_search": "Wyszukiwanie zaawansowane",
			"export_is_ready": "Export jest gotowy. ",
			"download": "Pobierz",
			"please_wait_generating_export": "Proszę czekać, eksport się generuje.",
			"please_wait_generating_export2": "Możesz zamknąć to okno. Gdy eksport jest gotowy, zostaniesz powiadomienie o linku do pobierania.",
			"click_to_download_export": "Aby pobrać eksport, kliknij przycisk Pobierz",
			"exported": "Eksportowano",
			"close": "Zamknij",
			"n_products": "Produkty",
			"template_exported": "Szablon został wyeksportowany",
			"export_template": "Eksportuj szablon",
			"import_template": "Zaimportuj szablon",
			"link_image_url": "Adres zdjęcia",
			"link_fie": "Zdjęcie z Feed Image Editoru",
			"link_mergado": "Produkt w MERGADO",
			"link_eshop": "Produkt w E-shopie",
			"template_not_found": "Nie znaleziono szablonu!",
			"template_preview": "Podgląd",
			"template_is_dynamic": "Szablon z elementami dynamicznymi",
			"input_width": "Szerokość obrazu wejśc.",
			"input_height": "Wysokość obrazu wejśc.",
			"product_content_type": "Format obrazu",
			"product_content_length": "wielkość wejściowa [kB]",
			"rendered_content_length": "wielkość wyjściowa [kB]",
			"copy_to_clipboard": "Skopiuj do schowka",
			"copy_mergado_query": "Skopiuj zapytanie MERGADO",
			"copied_to_clipboard": "Skopiowano",
			"products_per_page": "Liczba produktów na podglądy stron",
			"layer_copied": "Warstwa została skopiowana do schowka",
			"ask_save_before_leave": "Twoje zmiany mogą nie zostać zapisane, jeśli wyjdziesz.",
			"ask_save_before_leave_title": "Wyjść bez zapisywania?",
			"ask_save_before_leave_leave": "Wyjdź",
			"ask_save_before_leave_stay": "Zostań",
			"history_undo": "Cofnij",
			"history_redo": "Przerobić",
			"history_initial": "Cofnij wszystko",
			"settings": "Ustawienia",
			"confirm_delete_format": "Czy naprawdę usuwasz format",
			"confirm_delete_format_yes": "Tak",
			"confirm_delete_format_no": "Ne",
			"templates_having_this_size": "Szablony z tym formatem",
			"project_settings": "Ustawienia projektu",
			"ui_settings": "Ustawienia interfejsu użytkownika",
			"output_image_format": "Ustawienie formatu wyjściowego",
			"output_image_compression": "Kopiuje obraz wyjściowy",
			"auto_compression_to_size": "Automatyczna kompresja do rozmiaru",
			"group_by_image": "Grupuj według obrazu",
			"products_per_page_on_list": "Liczba produktów",
			"ask_before_leave": "Zapytaj przed zapisaniem edytora, aby zapisać zmiany",
			"settings_value": "wartość",
			"settings_update_success": "Ustawienia zapisane",
			"settings_update_error": "Podczas zapisywania ustawień wystąpił błąd",
			"save_sizes_success": "Zapisany format",
			"save_sizes_error": "Wystąpił błąd podczas zapisywania formatu",
			"different_hash": "Dane mogą nie być aktualne",
			"filtered_items": "Filtrowane",
			"set_template_active_date_success": "Ustawiona data",
			"set_template_active_date_error": "Nie udało się ustawić daty",
			"from_date": "od",
			"to_date": "do",
			"is_active": "jest aktywny",
			"not_active": "nie jest aktywny",
			"is_date_limited": "Aktywny od - do",
			"active_now": "Aktywny teraz",
			"set_timer": "Ustaw minutnik",
			"show_more": "Więcej...",
			"show_less": "Mniej...",
			"output_image_preview": "Podgląd obrazu wyjściowego",
			"output_image_content_length": "Długość",
			"original_output_image_content_length": "Pierwotnie",
			"less_than_original": "mniej niż pierwotnie",
			"more_than_original": "więcej niż pierwotnie",
			"about": "około",
			"has_no_watermark": "Nie zawiera znaku wodnego",
			"has_watermark": "Zawiera znak wodny",
			"watermark_status": "Znak wodny na obrazku",
			"hiding_products": "Ukrywanie produktów",
			"hide_products_by_filter": "Ukryj produkty według filtra",
			"unhide_products": "Odkryć",
			"hidden_by_filter": "Ukryty przez filtr",
			"hide_by_has_watermark": "Ukryj produkty ze znakami wodnymi",
			"hide_by_wrong_placement": "Ukryj produkty z nieprawidłowym rozmieszczeniem obrazu",
			"hide_by_low_quality": "Ukryj produkty niskiej jakości",
			"hide_by_seo_large_file": "Ukryj produkty z szerokim obrazem pod kątem SEO",
			"filter_content_length_gt": "Długość treści większa niż ... [kB]",
			"filter_content_length_lt": "Długość treści mniejsza niż ... [kB]",
			"set_by_user": "Zestaw użytkownika",
			"filter_empty_content": "Pusta zawartość obrazu",
			"filter_no_image": "Brak obrazu",
			"is_collage": "Układ",
			"all_available_only": "Tylko wtedy, gdy wszystkie alternatywne obrazy są dostępne",
			"single_image": "Jeden obraz produktu",
			"collage_layout": "Wybierz układ",
			"export_layouts": "Eksportuj układy",
			"import_layouts": "Importuj układy",
			"export_gradients": "Eksportuj gradienty",
			"import_gradients": "Importuj gradienty",
			"main_image": "Obraz",
			"alt_image": "Alt",
			"alternative_images": "Alternatywne obrazy",
			"save_layouts_error": "Wystąpił błąd podczas zapisywania",
			"save_layouts_success": "Zapisane",
			"delete_layouts_error": "Wystąpił błąd podczas usuwania układu. Układ jest używany w szablonie.",
			"delete_layout_image_error": "Błąd podczas usuwania obrazu z układu",
			"delete_layouts_success": "Usunięte",
			"add_layout_image_success": "Obraz dodany do układu",
			"add_layout_image_error": "Wystąpił błąd podczas dodawania obrazu układu",
			"create_default_layouts": "Ponownie utwórz domyślny zestaw układów",
			"create_default_layouts_success": "Pomyślnie utworzono domyślny układ",
			"create_default_layouts_error": "Błąd podczas tworzenia domyślnego układu",
			"delete_all_unused": "Usuń wszystkie nieużywane",
			"delete_all_unused_success": "Pomyślnie usunięto",
			"delete_all_unused_error": "Błąd podczas usuwania",
			"layout_name": "Nazwa układu",
			"selected_layout_image": "Wybrany obraz",
			"add_layout": "Dodaj układ",
			"delete_layout": "Usuń układ",
			"delete_layout_image": "Usuń obraz układu",
			"add_layout_image": "Dodaj obraz układu",
			"save_all_layouts": "Zapisz wszystkie układy",
			"save_layout": "Zapisz układ",
			"padding_px": "Przesunięcie obrazu [px]",
			"assigned_image": "Przypisany obraz",
			"units": "Jednostki",
			"layout_pos": "Miejsce",
			"layout_size": "Rozmiar",
			"add_layout_success": "Dodano nowy układ",
			"add_layout_error": "Wystąpił błąd podczas dodawania układu",
			"template_sizes": "Wymiary obrazu wyjśc",
			"save_order": "Zapisz zamówienie",
			"save_settings_order_success": "Zapisano kolejność ustawiania",
			"save_settings_order_error": "Błąd zapisywania zamówienia",
			"import_template_success": "Szablon został zaimportowany",
			"import_template_error": "Błąd podczas importowania szablonu",
			"representative_colors": "Reprezentatywne kolory z obrazu",
			"shortcuts": "Skróty klawiaturowe",
			"shortcut_ins": "Dodaj nową warstwę",
			"shortcut_del": "Usuń warstwę",
			"shortcut_save": "Zapisz szablon",
			"shortcut_undo": "Wróć",
			"shortcut_redo": "Przywróć",
			"shortcut_copy": "Skopiuj warstwę",
			"shortcut_paste": "Wstaw warstwę",
			"product_is_rendering": "Generowanie podglądu",
			"product_is_loading": "Ładowanie produktu",
			"is_saving": "Oszczędzam",
			"invalid_filed_value": "Niepoprawna wartość pola",
			"value_not_set": "nie ustawiono",
			"font_not_found": "Nie znaleziono czcionki. Zastąpione domyślnie.",
			"radius": "Promień",
			"gradient_type_linear": "Liniowy",
			"gradient_type_radial": "Promieniowy",
			"no_gradient": "Brak gradientu",
			"select_gradient": "Wybierz gradient",
			"select_gradients": "Wybierz gradienty",
			"save_as_new_gradient": "Zapisz jako nowy gradient",
			"info_gradients_not_saved": "Zmiany gradientu nie zostały jeszcze zapisane",
			"gradient": "Gradient",
			"gradients": "Gradienty",
			"confirm_remove_gradient": "Usunąć ten gradient?",
			"palettes": "Palety kolorów",
			"predefined_colors": "Predefiniowane kolory",
			"brand_colors": "Kolory marki",
			"custom_colors": "Niestandardowe palety kolorów",
			"select_palette": "Wybierz paletę",
			"extract_colors_from_image": "Wyodrębnij kolory z obrazu",
			"add_to_custom_palettes": "Dodaj do niestandardowych palet",
			"save_custom_colors": "Zapisz własne kolory",
			"save_as_default": "Zapisz jako domyślny",
			"saved": "Zapisane",
			"no_changes": "Bez zmian",
			"no_custom_palettes": "Nie masz jeszcze żadnych niestandardowych palet",
			"create_layer_group": "Utwórz grupę warstw",
			"group": "Do grupy",
			"ungroup": "Rozgrupować",
			"delete_layer_group": "Anuluj grupę warstw",
			"toggle_visibility": "Przełącz widoczność",
			"delete_layers": "Usuń warstwy",
			"delete_layer": "Usuń warstwę",
			"duplicate_layer": "Powielona warstwa",
			"duplicate_layers": "Powielone warstwy",
			"edit_layer": "Edytuj warstwę",
			"lock_layer": "Zablokuj warstwę",
			"unlock_layer": "Odblokuj warstwę",
			"thickness": "Grubość",
			"brightness": "Jasność",
			"contrast": "Kontrast",
			"show_products": "Pokaż produkty",
			"reset_effects": "Anuluj efekty",
			"auto_level": "Automatyczny balans kolorów",
			"alpha": "Przezroczystość",
			"save_as_query": "Zapisz jako<br/> wybór",
			"save_as_query_title": "Zapisz jako wybór",
			"fie_query_type": "Rodzaj",
			"fie_query_name": "Nazwa wyboru",
			"fie_query_element": "Nazwa nowego elementu w MERGADO",
			"fie_query_filter": "Filtr produktu",
			"fie_query_is_active": "Aktywny",
			"query_in_use": "Ten wybór jest używany w szablonie",
			"fie_queries": "Wybory",
			"fie_queries_info": "Výběry - TODO: napověda",
			"no_fie_queries_yet": "Nie masz jeszcze wyboru produktów. Możesz je utworzyć w sekcji produktów.",
			"toggle_active": "Przełącznik aktywny / nieaktywny",
			"set_active": "Przełącznik aktywny",
			"set_inactive": "Przełącznik nieaktywny",
			"image": "Obrazek",
			"mergado_connection_verifying": "Weryfikacja połączenia z MERGADA",
			"show_in_mergado": "Pokaż w MERGADO",
			"mergado_queries": "Wybory",
			"mergado_products": "Produkty",
			"mergado_formats": "Formaty",
			"mergado_elements": "Elementy",
			"output_image_element": "Element obrazu wyjściowego",
			"output_image_hidden_warning": "Uwaga, element obrazu wyjściowego dla tego typu eksportu jest ukryty",
			"not_empty_error": "To pole jest obowiązkowe",
			"drop_shadow": "Cień",
			"shadow_color": "Kolor cienia",
			"shadow_opacity": "Krycie",
			"shadow_sigma": "Blur",
			"shadow_offset": "Przesunięcie cienia",
			"shadow_xoffset": "X",
			"shadow_yoffset": "Y",
			"effect_sensitivity": "Czułość efektu",
			"sensitivity": "czułość",
			"LOW": "niski",
			"MEDIUM": "średni",
			"HIGH": "wysoki",
			"too_big_for_upscale": "Obraz jest większy niż 600 x 600 pikseli, nie można zastosować skalowania w górę. Proszę załadować inny losowy obraz.",
			"only_main_image": "tylko główny obraz",
			"other_effects": "Inne efekty",
			"flood_fill_points": "Zwrotnica",
			"fuzz": "Dyspersja",
			"heureka_175x175": "Heureka – zalecane wymiary",
			"heureka_4096x4096": "Heureka – maksymalne wymiary",
			"zoot_1000x745": "Zoot – minimalne wymiary",
			"zoot_1907x2562": "Zoot – zalecane wymiary",
			"zbozi_425x440": "Zboží.cz – minimalne wymiary",
			"zbozi_600x800": "Zboží.cz – minimalne wymiary (towary używane)",
			"google_100x100": "Google Merchants – minimalne wymiary",
			"google_250x250": "Google Merchants – minimalne wymiary zdjęć odzieży",
			"google_500x500": "Google Merchants – minimalne wymiary *od 31.01.2027",
			"google_1500x1500": "Google Merchants – zalecane wymiary",
			"glami_400x400": "GLAMI – minimalne wymiary",
			"glami_1500x1500": "GLAMI – zalecane wymiary",
			"alza_600x600": "ALZA – minimalne wymiary",
			"alza_1000x1000": "ALZA – minimalne zalecane wymiary",
			"alza_1300x1300": "ALZA – maximalne zalecane wymiary",
			"favi_600x600": "FAVI – minimalne wymiary",
			"favi_1000x1000": "FAVI – zalecane wymiary",
			"biano_400x400": "BIANO – minimalne wymiary",
			"biano_1500x1500": "BIANO – zalecane wymiary",
			"shopalike_250x250": "Shopalike – minimalne wymiary",
			"shopalike_1024x1024": "Shopalike – zalecane wymiary",
			"instagram_1024x1024": "Instagram – zalecane wymiary",
			"instagram_1080x1080": "Instagram",
			"instagram_1080x1350": "Instagram",
			"instagram_1080x566": "Instagram",
			"instagram_1080x1920": "Instagram",
			"instagram_1440x1800": "Instagram",
			"instagram_1440x2560": "Instagram",
			"allegro_500x500": "Allegro – minimalne wymiary",
			"allegro_2560x2560": "Allegro – maximalne wymiary",
			"facebook_1024x1024": "Facebook – zalecane wymiary",
			"facebook_500x500": "Facebook – minimalne wymiary",
			"facebook_600x600": "Facebook",
			"facebook_1080x1080": "Facebook",
			"facebook_1200x1200": "Facebook",
			"facebook_1080x1350": "Facebook",
			"facebook_1200x628": "Facebook",
			"facebook_1440x1440": "Facebook",
			"facebook_1440x1800": "Facebook",
			"facebook_1440x2560": "Facebook",
			"modio_500x500": "Modio – minimalne wymiary",
			"modio_1024x1024": "Modio – zalecane wymiary",
			"modio_2048x2048": "Modio – maximalne wymiary",
			"mall_1280x1024": "Mall – minimalne wymiary",
			"mall_2000x2000": "Mall – maximalne wymiary",
			"kaufland_1024x1024": "Kaufland – minimalne wymiary",
			"kaufland_2048x2048": "Kaufland – zalecane wymiary",
			"snapchat_200x200": "Snapchat – minimalne wymiary",
			"pinterest_200x300": "Pinterest – minimalne wymiary",
			"pinterest_600x900": "Pinterest – minimalne wymiary",
			"pinterest_1000x1500": "Pinterest – zalecane wymiary",
			"pinterest_1080x1920": "Pinterest – zalecane wymiary",
			"pinterest_1080x1080": "Pinterest",
			"find_format": "Znajdź format",
			"custom_formats": "Formaty niestandardowe",
			"other_formats": "Inne formaty",
			"elements_availability": "Dostępność elementów w szablonach dynamicznych",
			"product_elements": "Elementy",
			"filter_missing_elements": "Filtruj brakujące lub puste elementy",
			"only_updated_products": "Tylko produkty, które przeszły regulamin po zapisaniu szablonu",
			"ok": "OK",
			"empty_elements": "Puste elementy",
			"toggle_snap_to_guides": "Przyciągaj",
			"toggle_snap_to_grid": "Przyciągaj do siatki",
			"toggle_snap_to_element": "Przyciągaj do elementu",
			"show_grid": "Siatka",
			"snap_strength": "Siła przyciągania",
			"is_anim_gif": "Animowany GIF",
			"outpainting": "Outpainting",
			"frames_delay": "Opóźnienie między klatkami [ms]",
			"loops_delay": "Opóźnienie na końcu pętli [ms]",
			"info_no_active_template": "W tym momencie nie masz aktywnych szablonów. Feed Image Editor zacznie pracować, kiedy aktywujesz jeden lub więcej szablonów.",
			"info_no_template": "<b>Stworzyłeś szablon.</b><br/>Wybierz jeden z gotowych szablonów z galerii lub stwórz swój własny.",
			"info_workshop": "Naucz się jak korzystać z Feed Image Editor. Zapisz się na darmowe warsztaty. <span class=\"link\" onClick=Mergado.openWindow(\"https://www.feed-image-editor.pl/workshop\")>Dowiedz się więcej</span>.",
			"replace_color": "Wymiana koloru",
			"target_color": "Zastąp kolor",
			"replace_by_color": "Według koloru",
			"add_point": "Dodaj punkt",
			"info_no_points": "Możesz dodawać punkty, klikając płótno",
			"projects_overview": "Przegląd projektów",
			"system": "System",
			"project_info": "Projekt",
			"templates": "Szablony",
			"random_images": "Losowe obrazy",
			"rules": "Zasady",
			"queries": "Wybory",
			"rabbit": "RabbitMQ",
			"points_coordinates": "Względne położenie punktów",
			"no_images_found": "Nie znaleziono produktów zawierających obrazy",
			"show_helper": "Pokaż pomocnika",
			"disable_helper": "Nie pokazuj pomocnika",
			"disable_wheelzoom": "Wyłącz zoom kółkiem myszy",
			"helper_ok": "Ok",
			"helper_close": "Nie pokazuj pomocnika",
			"helper": "Pomocnik",
			"need_help_title": "Potrzebujesz porady?",
			"need_help_text": "W przypadku jakichkolwiek sugestii lub problemów prosimy o kontakt z naszym wsparciem <a href=\"mailto:support@feedimageeditor.com\" class=\"mail-link\">support@feedimageeditor.com</a>.",
			"bezier_no_points": "<ul><li class=\"right-arrow-marker\">Kliknij płótno, aby dodać nowy punkt krzywej</li></ul>",
			"bezier_add_points": "<ul><li class=\"right-arrow-marker\">Kliknij płótno, przytrzymaj przycisk i dostosuj punkty kontrolne, przeciągając myszą. Następnie zwolnij przycisk i możesz ustawić więcej punktów.</li></ul>",
			"bezier_unselect": "<ul><li>Aby zmienić aktywną warstwę, możesz użyć prawego przycisku myszy lub przełącznika na liście warstw.</li></ul>",
			"has_reflection": "Odbicie",
			"angle": "Kąt",
			"reflection_offset": "Offsetowy",
			"reflection_opacity": "Przezroczystość",
			"reflection_flip": "Trzepnięcie",
			"helper_no_queries": "<ul><li class=\"info-marker\">Wybierz wybór produktu, do którego zostanie zastosowany szablon. Użyj filtru, aby znaleźć wybór.</li></ul>",
			"helper_one_query": "<ul><li>Możesz dokonać większej liczby wyborów</li></ul>",
			"helper_at_least_one_query": "<ul><li>Zawsze znajdziesz wybrane pozycje na górze listy.</li></ul>",
			"helper_zero_products_query": "<ul><li class=\"exclamation-marker\">Wybrany wybór nie zawiera żadnych produktów.</li></ul>",
			"helper_no_format": "<ul><li class=\"info-marker\">Wybierz jeden z formatów wyjściowych. Możesz utworzyć własny format na końcu listy lub w Ustawieniach.</li></ul>",
			"helper_format_selected": "<ul><li>Wybierz jedną z opcji dostosowywania obrazu.</li><li>W razie potrzeby dostosuj ręcznie szerokość nakładania.</li></ul>",
			"helper_no_layer": "<ul><li class=\"info-marker\">Kliknij opcję Nowa warstwa, aby dodać tekst, etykiety, grafikę i nie tylko do obrazów.</li></ul>",
			"helper_at_least_one_layer": "<ul><li>Aby zmienić kolejność warstw, {ArrowVIcon} przesuń.</li><li>Warstwy z elementami mają ustaloną kolejność u góry obszaru roboczego.</li><li>Nie zapomnij nazwać i zapisać szablonu.</li></ul>",
			"helper_two_more_layers": "<ul><li>Przytrzymaj klawisz <span class=\"framed\">CTRL</span>  i najedź kursorem na wiele warstw. Użyj przycisku {GroupIcon} aby pogrupować je w jedną warstwę. Użyj tego samego przycisku, aby z powrotem podzielić warstwę.</li><li>Linie pomocnicze ułatwiają wyrównywanie warstw. Aktywujesz je i dezaktywujesz za pomocą przycisku {MagnetIcon}</li></ul>",
			"layers": "Warstwy",
			"brush_spacing": "Odległość",
			"brush_color": "Kolor pędzla",
			"brush_pattern": "Wzór",
			"brush_pattern_color": "Kolor wzoru",
			"brush_rotate_pattern": "Obróć wzór",
			"linewidth_profile": "Profil szerokości linii",
			"uniform": "mundur",
			"fade_out": "stopniowo słabnąć",
			"fade_in": "stopniowo zwiększać siłę",
			"fading": "osłabiać na końcach",
			"zoom_in": "zbliżenie",
			"zoom_out": "pomniejsz",
			"token_not_provided": "Błąd uwierzytelniania - nie podano tokena",
			"toast_online_call": "Czy potrzebujesz pomocy przy tworzeniu swojej pierwszej kampanii wizerunkowej? Umów się na spotkanie <span class=\"link\" onClick=Mergado.openWindow(\"https://calendly.com/feed-image-editor\")> online z Markiem</span>, który z przyjemnością doradzi Ci, jak najlepiej wykorzystać możliwości Feed Image Editor do maksimum.",
			"online_call_header": "Chcesz pomocy przy konfiguracji lub inspiracji dla swoich kampanii?",
			"online_call": "Zarezerwuj krótką, bezpłatną konsultację z Markiem. Pokaże Ci najlepsze praktyki dla Twojego typu e-sklepu, pomoże z ustawieniami i odpowie na wszystkie pytania.",
			"watermark_mask": "Maska znaku wodnego",
			"watermark_masked_image": "Zamaskowany znak wodny",
			"watermark_group": "Grupa znaków wodnych",
			"watermark_groups": "Grupy znaków wodnych",
			"watermark_methods": "Metody usuwania znaku wodnego",
			"create_new_group": "Utwórz nową grupę",
			"new_group": "Nowa grupa",
			"required_field": "Pole wymagane",
			"no_watermark_masks": "Nie wybrałeś jeszcze żadnych znaków wodnych",
			"downloaded": "Pobrano",
			"status_ok": "Stan OK",
			"waiting_to_process": "Oczekiwanie na przetwarzanie",
			"inpaint_error": "Błąd usuwania znaku wodnego",
			"watermark_group_not_selected": "Najpierw wybierz grupę znaków wodnych",
			"background": "Tło",
			"remove_background": "Usuń tło",
			"solid_bg": "Jednolity kolor",
			"light_bg": "Jasne tło",
			"dark_bg": "Ciemne tło",
			"background_colors": "Zabarwienie",
			"background_shade": "Odcień tła",
			"not_transparent_bg": "Nieprzezroczyste tło",
			"transparent_bg": "Przezroczyste tło",
			"multicolor_bg": "Wielokolorowe",
			"status_not_recommended_colorspace": "Kolorowe modele",
			"not_recommended_colorspace": "Kolorowe modele",
			"not_recommended_colorspace_description": "Twoje obrazy są w zapisane z użyciem modelu kolorów CMYK, który nie pozwala na wyświetlanie obrazów na komputerach stacjonarnych lub urządzeniach mobilnych. Takie obrazy nie zachęcają kupujących. Przekonwertuj obrazy na model kolorów RGB.",
			"status_unsupported_background": "Niewłaściwe tło",
			"unsupported_background": "Niewłaściwe tło",
			"unsupported_background_description": "Reklamy mogą być ograniczone a obrazy moga nie wyświetlać się właściwie ponieważ co wystąpiło co najmniej jedno z poniższych ostrzeżeń. Aby polepszyć jakość swoich reklam i obrazów produktu zastosuj jedną z poniższych sugestiii. Jeśli wprowadzisz obrazy lub produkty z kolorowym tłem, to nie będą one wyświetlane w reklamach. ",
			"set_watermark_group_first": "Najpierw ustaw grupę znaków wodnych!",
			"unknown_preview_image_error": "Błąd podczas ładowania obrazu",
			"render_preview_error_6": "Nieznana domena",
			"render_preview_error_1": "Obraz źródłowy jest pusty",
			"render_preview_error_420": "Nieznany format",
			"render_preview_error_450": "Obraz PNG ma zły CRC",
			"render_preview_error_28": "Serwer, na którym obraz nie odpowiada",
			"render_preview_error_35": "Błąd SSL",
			"first_steps_wizard": "Przewodnik pierwszej konfiguracji",
			"skip_wizard": "Nie potrzebuję kreatora, chcę przejść do aplikacji",
			"close_wizard": "Zamknij kreatora",
			"input_elements_map": "Ustawienia elementów wejściowych",
			"input_output_format": "Ustawienia formatu wejściowego i wyjściowego",
			"first_steps_create_template": "Gotowe. Wszystko gotowe do stworzenia pierwszego szablonu.",
			"first_step_info": "Witamy w aplikacji Feed Image Editor, która pomoże Ci zbiorczo edytować obrazy produktów Twojego e-sklepu dla rynków, sieci społecznościowych i porównywarek.<br/>W pierwszym kroku wybierz kanał, na którym chcesz się reklamować:",
			"first_step_info_old": "Witamy w aplikacji Feed Image Editor, która pomoże Ci edytować obrazy w Twoim e-sklepie. <br/>W pierwszej kolejności upewnij się, że wybraliśmy właściwe elementy z Twojego kanału do wykorzystania w edytorze. Następnie możesz od razu zacząć tworzyć pierwszy szablon.",
			"next_step": "Następny krok",
			"previous_step": "Poprzedni krok",
			"input_format": "Format wejściowy",
			"output_format": "Format wyjściowy",
			"preferred_product_preview": "Podgląd preferowanego produktu",
			"date_placeholder": "DD. MM. RRRR",
			"today": "Dziś",
			"news_box_header": "Zobacz nowości w aolikacji",
			"news_box_body": "<h4>Edytuj zdjęcia produktów bezpośrednio w czacie</h4><p>Feed Image Editor obsługuje teraz serwer MCP, co pozwala połączyć asystentów AI, takich jak Claude czy ChatGPT, bezpośrednio z edytorem. Zamiast klikać w interfejsie, wystarczy wpisać polecenie na czacie, a asystent:<ul><li>skonfiguruje szablony i parametry edycji</li><li>przypisze produkty na podstawie dokonanego wyboru</li><li>zmieni rozmiar zdjęć, usunie tło lub zwiększy rozdzielczość</li></ul><p>Jeśli masz już połączonego asystenta AI przez Mergado MCP, Feed Image Editor MCP zadziała automatycznie – bez dodatkowej konfiguracji. Jeśli jeszcze nie korzystasz z MCP, wystarczy kliknąć link i połączyć usługę w kilka chwil.</p>",
			"news_box_body_link": "Dowiedz się więcej →",
			"select_template_queries": "Najpierw wybierz produkty, do których chcesz zastosować szablon",
			"set_output_image_size": "Dostosuj rozmiar obrazów wyjściowych",
			"select_from_template_gallery": "Możesz wybrać jeden z naszych gotowych szablonów",
			"main_image_or_collage": "Wybierz, czy chcesz wydrukować tylko główny obraz, czy kolaż głównych i alternatywnych obrazów",
			"main_image_on_canvas_placement": "Umieść główny obraz na płótnie",
			"set_collage_layout": "Ustaw układ kolażu. Aby uzyskać lepszy efekt, zalecamy włączenie funkcji usuwania tła.",
			"set_anim_gif": "Ustaw ostateczny wygląd animowanego pliku GIF",
			"position_and_rotation": "Pozycja i rotacja",
			"apply_ai_effects_or_filters": "Zastosuj efekty AI lub filtry do obrazu produktu",
			"editor_step_5": "Wybierz, czy szablon ma być uruchamiany natychmiast po utworzeniu, czy w wybranym dniu",
			"editor_step_6": "Wizualne podobieństwo obrazów",
			"editor_step_7": "Dodaj więcej warstw z elementami graficznymi",
			"helper_tips": "<ul><li>Czy chciałbyś użyć w aplikacji własnej czcionki? Napisz do nas na support@feedimageeditor.com</li><li>Czy wiesz, że w edytorze możesz używać skrótów klawiaturowych?<div class='quote'><span class='framed'>Ins</span><span>Dodaj nową warstwę</span><br/><span class='framed'>Del</span><span>Usuń warstwę</span><br/><span class='framed'>Ctrl + s</span><span>Zapisz szablon</span><br/><span class='framed'>Ctrl + z</span><span>Wróć</span><br/><span class='framed'>Ctrl + y</span><span>Przywróć</span><br/><span class='framed'>Ctrl + c</span><span>Skopiuj warstwę</span><br/><span class='framed'>Ctrl + v</span><span>Wstaw warstwę</span></div></li></ul>",
			"more_fonts": "Czy chciałbyś użyć w aplikacji własnej czcionki? Napisz do nas na <a href=\"mailto:support@feedimageeditor.com\" class=\"mail-link\">support@feedimageeditor.com</a>",
			"editor_step_0": "Wybierz typ szablonu",
			"layout": "Układ obrazu",
			"autoonoff": "Planer aktywności",
			"success": "W porządku",
			"zoom": "Powiększenie",
			"pan": "Panoramowanie",
			"draw": "Remis",
			"move": "Ruszaj się",
			"reset_zoom": "Reset zoom",
			"queued_at": "W kolejce",
			"score": "Wynik",
			"ai_tools": "Narzędzia sztucznej inteligencji",
			"missing_symbols": "Czcionka nie zawiera wszystkich symboli, podgląd na żywo i renderowany obraz mogą się różnić.",
			"characters": "pismo",
			"recently_used": "Ostatnio używane",
			"set_background": "Ustaw tło",
			"filters": "Filtry",
			"remove_background_error": "Wystąpił błąd podczas usuwania tła obrazu",
			"cannot_remove_background": "Nie możemy wiarygodnie usunąć tła tego obrazu",
			"object_to_image_ratio": "Obiekt/obraz",
			"template_id": "template id",
			"disable_show_overlap": "Nie pokazuj strefy w podglądzie",
			"font_example": "Pchnąć w tę łódź jeża lub ośm skrzyń fig.",
			"unsupported_mime_type": "Niewłaściwy typ mim",
			"unsupported_file_size": "Plik jest za duży",
			"selection": "Wybór",
			"is_transparent": "Przezroczyste tło",
			"is_light_bg": "Jasne tło",
			"orientation": "Orientacja obrazu",
			"portrait": "Pionowa",
			"landscape": "Pozioma",
			"bg_color_distance": "Odległość koloru",
			"small_distance": "mały",
			"big_distance": "duża",
			"medium_distance": "średni",
			"bg_color": "Kolor tła",
			"create": "Stwórz",
			"create_predefined_fie_queries_title": "Którego z poniższych wyborów chcesz dokonać?",
			"create_predefined_fie_queries_text": "Utworzyć wstępnie zdefiniowane FIE wybory?",
			"active_supereffect": "Aktywny super efekt",
			"not_number": "Nie numer",
			"prepared_text": "Przygotowany tekst",
			"get_now": "promocja",
			"discount": "zniżka",
			"discount_and_frame": "Zniżka & ramka",
			"1_plus_1_circle": "1 + 1 GRATIS",
			"buy_one_get_one_free": "1+1 gratis",
			"last_piece": "Ostatni kawałek",
			"new_year_sale": "Noworoczna wyprzedaż",
			"free_gift": "prezent gratis",
			"add_to_cart": "do koszyka",
			"sale": "wyprzedaż",
			"buy_now": "kup teraz",
			"buy": "kup",
			"order_now": "zamów",
			"free_delivery": "darmowa dostawa",
			"newie": "nowość",
			"in_stock": "w magazynie",
			"project_health": "Zdrowie projektu",
			"find_by": "Znajdować",
			"fonts": "Czcionki",
			"send_mailgun_notifications": "Wysyłanie powiadomień systemowych i wskazówek na pocztę",
			"force_remove_alpha": "Usunięcie kanału alfa z obrazu przed wysłaniem go do usunięcia tła",
			"auto_template_priority": "Automatycznie uporządkuj kolejność szablonów",
			"no_watermark_mask_defined": "Musisz najpierw wybrać maskę znaku wodnego",
			"brush": "Pędzel",
			"eraser": "Gumka",
			"main_image_opt": "Zdjęcie główne",
			"layout_opt": "Kolaż",
			"skip_refresh_images": "Pobieraj obrazy tylko wtedy, gdy zmieni się ich adres URL",
			"skip_refresh_images_hint": "Serwer z zapisanymi obrazami nie zużywa tak dużo. Uwaga: jeśli adres URL obrazu pozostaje ten sam, zmienia się tylko treść, ta zmiana nie może zostać wykryta automatycznie.",
			"or": "lub",
			"preferred_product_id": "Preferowany identyfikator",
			"random_product_id": "Załadowany produkt",
			"other": "inny",
			"group_all_templates": "Wszystkie szablony",
			"group_discounts_and_sales": "Rabaty i wyprzedaże",
			"group_black_friday": "Black Friday",
			"group_gift": "Darmowy prezent",
			"group_free_delivery": "Darmowa dostawa",
			"group_new_year_sale": "Noworoczna wyprzedaż",
			"group_viva_magenta": "Viva Magenta",
			"group_midjourney": "Midjourney",
			"group_generic": "Uniwersalne szablony",
			"group_new": "Nowości",
			"group_seasonal": "Kampanie sezonowe",
			"group_availability": "Dostępność magazynowa",
			"group_christmas": "Świąteczna kampania",
			"group_effects": "Efekty",
			"group_background": "Tło",
			"group_warranty": "Gwarancja",
			"group_valentine": "Walentynki",
			"group_size_variant": "Warianty rozmiarowe",
			"custom": "Dodaj",
			"no_watermark_groups_yet": "Nie masz jeszcze żadnych grup znaków wodnych.",
			"no_watermark_groups_published_yet": "Nie masz jeszcze przesłanych grup znaków wodnych.",
			"start_here": "Zacznij tutaj",
			"select_images_to_watermark_groups": "Wybierz kilka obrazów z tym samym znakiem wodnym.",
			"watermark_groups_info_0": "Dla każdego rodzaju znaku wodnego musisz oznaczyć kilka obrazów tym samym znakiem wodnym. Te obrazy będą używane do trenowania modelu.",
			"watermark_groups_info_1": "todo",
			"images_from_mergado": "Obrazy z MERGADO",
			"images_from_fie": "Zdjęcia produktów z regulaminu",
			"images_from_upload": "przesłane obrazy",
			"select_images_with_same_watermark": "Wybierz obrazy",
			"create_watermark_mask": "Pomaluj znak wodny pędzlem",
			"create_watermark_group": "Utwórz",
			"create_new_watermark_group": "Vytvořit novou skupinu obrázků",
			"append_to_watermark_group": "Połącz",
			"to_wm_group": "do grupy",
			"add": "Dodać",
			"add_image": "Dodaj zdjęcie",
			"no_watermark_mask": "Proszę zaznaczyć znak wodny",
			"publish_to_trainer": "Wyślij do pociągu",
			"images_in_group": "Zdjęcia w grupie",
			"rename": "Przemianować",
			"group_exists": "Grupa o tej nazwie już istnieje",
			"cannot_be_empty": "Nie może być pusty",
			"sent": "Wysłano",
			"confirm_remove_group_image": "Usunąć obraz z grupy znaków wodnych?",
			"confirm_remove_group": "Usuń grupę znaków wodnych",
			"empty_watermark_group": "Grupa znaków wodnych nie zawiera żadnych obrazów. Zacznij od przesłania zdjęć do grupy.",
			"unpublished_group": "Grupa nie została wysłana do szkolenia modelki",
			"watermark_group_hash_diff": "Grupa została zmieniona. Musisz wysłać ponownie na szkolenie.",
			"watermark_group_some_images_without_mask": "Niektóre produkty z tej grupy nie posiadają znaku wodnego.",
			"spacing": "Rozstaw",
			"line_spacing": "Odstępy między wierszami",
			"letter_spacing": "Tracking",
			"lines_and_letters_spacing": "Odstępy między literami",
			"publish_to_detector": "Wyślij do detektora znaku wodnego",
			"published": "Wysłano",
			"no_gradients_yet": "Nie masz jeszcze utworzonego gradientu",
			"results": "Wyniki",
			"no_results_yet": "Brak wyników",
			"template_name_max_100": "maksymalna długość nazwy to 100 znaków",
			"clockwise": "Zgodnie ze wskazówkami zegara",
			"counter_clockwise": "Przeciwnie do ruchu wskazówek zegara",
			"no_color": "brak",
			"text_stroke": "Obrys tekstu",
			"text_stroke_underlayer": "Kontur jako tło (grubość tekstu pozostaje bez zmian)",
			"text_stroke_inside": "Obrys wokół tekstu kosztem jego grubości",
			"text_padding": "Wypełnienie tekstu",
			"select_format_to_see_templates": "Aby wyświetlić szablony graficzne, należy najpierw wybrać format obrazu wyjściowego.",
			"warn_inactive_fie_queries": "Te predefiniowane wybory nie są aktywne",
			"warn_rules_not_applied_yet": "Te wybory nie są jeszcze wyświetlane, ponieważ reguły nie zostały uruchomione",
			"random_colors": "Losowe kolory",
			"random_gradients": "Losowe gradienty",
			"dominant_color": "Kolor z produktu",
			"warn_transparent_background": "Jeśli chcesz, aby obrazy wyjściowe miały <b>przezroczyste tło</b>, wybierz .png jako format wyjściowy w Ustawieniach.",
			"import_palette": "Importuj paletę",
			"delete_palette": "Usuń paletę",
			"add_color": "Dodaj kolor",
			"group_easter_campaign": "Kampania wielkanocna",
			"happy_easter": "Wesołego Alleluja",
			"easter_discounts": "Rabaty wielkanocne",
			"easters": "WIELKANOC",
			"spring": "WIOSENNY",
			"spring_sales": "Wiosenna wyprzedaż",
			"spring_discounts": "Wiosenne rabaty",
			"discounts": "OBROTY",
			"discount_30": "ZNIŻKA 30%",
			"discounts_30": "RABATY -30%",
			"up_to_20": "do 20%",
			"right": "TYLKO",
			"now": "TERAZ",
			"click_here": "KLIKNIJ TUTAJ",
			"buy_here": "KUP TUTAL",
			"watermark_mark_images": "Wybierz i oznacz od 10 do 15 obrazów zawierających ten sam znak wodny.",
			"watermark_max_images": "Max 15 obrazów",
			"watermark_min_images": "Min 10 obrazów",
			"marked_watermarks": "zaznaczone znaki wodne",
			"not_published_yet": "jeszcze nie wysłane",
			"text_orientation": "Orientacja tekstu",
			"horizontal_orientation": "poziomo",
			"vertical_orientation": "pionowo",
			"clip_mask": "Maska przycinająca",
			"add_clip_mask": "Dodaj maskę przycinającą",
			"invert_clip_mask": "Odwróć maskę przycinającą",
			"finish": "Skończyć",
			"watermark_is_marked": "Znak wodny jest zaznaczony",
			"already_used_image": "Obraz został już użyty",
			"check_elements_title": "Sprawdzanie dostępności ręcznie wprowadzanych elementów",
			"some_elements_not_available": "Niektóre ręcznie wprowadzone elementy wydają się być niedostępne. Sugerowane zmiany to:",
			"apply_all_suggested_changes": "Zastosuj wszystkie sugerowane zmiany",
			"apply_only_selected_changes": "Zastosuj wybrane zmiany",
			"template_layer": "Warstwa szablonu",
			"e_img_url": "Element adresu URL obrazu",
			"e_img_url_input": "Wprowadź element adresu URL obrazu",
			"e_alt_img_url": "Element z adresem alternatywnego obrazu",
			"e_alt_img_url_input": "Wprowadź element adresu alternatywnego URL obrazu",
			"e_item_id": "Element identyfikatora przedmiotu",
			"e_name": "Element nazwy produktu",
			"e_productno": "Element numeru produktu",
			"e_price_vat": "Element ceny",
			"e_url": "Element adresu URL sklepu",
			"e_ean": "Element EAN",
			"template": "szablon",
			"layer": "warstwa",
			"audit_promo_templates": "Przykładowe szablony w audycie",
			"save_and_rerender_promo": "Save and re-render promo for existing projects",
			"reload_saved": "Reload saved",
			"back_to_predefined": "Back to predefined",
			"reset_filters": "Anuluj filtry",
			"has_complex_background": "Złożone tło",
			"complex_background_threshold": "próg dla złożonego tła",
			"empty_background_probability": "prawdopodobieństwo pustego tła",
			"object_bounding_box_to_image_ratio": "stosunek obwiedni obiektu do obrazu",
			"set_template_size": "Ustaw wymiary szablonu (zalecane)",
			"keep_original_image_size": "Zachowaj oryginalne wymiary obrazu",
			"no_template_size_is_selected_title": "Brak wymiarów szablonu",
			"no_template_size_is_selected": "Nie masz wybranych wymiarów szablonu. Jeśli w szablonie znajdują się inne warstwy, mogą one znajdować się poza widocznym obszarem.",
			"gradient_stop_points": "kolory końcowe gradientu",
			"is_autocrop": "Autocrop",
			"new_alternative_template": "Nowy alternatywny szablon obrazów",
			"alternative_template": "Alternatywny szablon obrazów",
			"alternative_templates": "Alternatywne szablony obrazów",
			"main_templates": "Główne szablony obrazów",
			"image_offset": "Przesunięcie obrazu względem zdefiniowanego kształtu",
			"collage_image_shape": "Kształt",
			"rect": "Prostokąt",
			"ellipse": "Elipsa",
			"selected": "Wybrany",
			"import": "Import",
			"no_templates_found": "Nie znaleziono żadnych szablonów",
			"auto_priority": "Automatycznie uporządkuj",
			"manual_priority": "Ułóż ręcznie",
			"right_now": "SHOP NOW",
			"limited_offer": "LIMITED OFFER",
			"sale2": "SALE",
			"sales_up_to_50": "UP TO 50%",
			"sale_up_to_50": "UP TO 50%",
			"sales_up_to": "SALE",
			"this_week": "THIS WEEK",
			"shop_here": "buy here",
			"discounts2": "DISCOUNTS",
			"textInsideShape": "Tekst wewnątrz kształtu",
			"element_not_selected": "nie wybrano żadnego elementu",
			"invalid_color": "nieprawidłowy kolor",
			"invalid_email": "nieprawidłowy adres e-mail",
			"letter_case": "Wielkość liter",
			"keep": "bez zmian",
			"to_upper_case": "wielkimi literami",
			"to_lower_case": "na małe litery",
			"first_letter_to_upper_case": "pierwsza litera wielka",
			"first_letter_to_lower_case": "pierwsza litera mała",
			"first_word_letter_to_upper_case": "pierwsza litera słowa wielka",
			"has_person": "A person in the picture",
			"person_detected": "has person",
			"person_not_detected": "person not detected",
			"columns": "Kolumny",
			"is_keep_size": "Zachowaj oryginalny format",
			"is_keep_size_info": "Wybrano zachowanie oryginalnych wymiarów. Nie można wstawiać warstw, tylko efekty.",
			"contact_email": "Kontaktowy e-mail",
			"element_short_item_id": "ITEM_ID",
			"element_short_url": "URL",
			"element_short_cpc": "CPC",
			"element_short_name": "NAME",
			"element_short_img_url": "IMG_URL",
			"element_short_img_url_input": "IMG_URL",
			"element_short_alt_img_url": "IMG_ALTERNATIVE",
			"element_short_alt_img_url_input": "IMG_ALTERNATIVE",
			"element_short_price_vat": "PRICE_VAT",
			"element_short_delivery_date": "DELIVERY_DATE",
			"element_short_manufacturer": "MANUFACTURER",
			"element_short_categorytext": "CATEGORY",
			"element_short_ean": "EAN",
			"steps_first_perex": "<h4>Witamy w aplikacji Feed Image Editor</h4><p class='perex'>Pomożemy ci szybko i łatwo edytować zdjęcia produktów dla twojego sklepu internetowego. Aby wszystko działało poprawnie, wspólnie ustawimy kilka podstawowych kroków.</p>",
			"steps_last_perex": "Teraz możesz przystąpić do poprawy zdjęć produktów. Wybierz, od którego rodzaju edycji chcesz rozpocząć w swoim wstępnym szablonie.",
			"steps_first_header": "Sprawdź elementy w swoim feedzie Mergado",
			"steps_first_subheader": "Zanim zaczniesz tworzyć pierwszą szablonę lub kampanię, upewnij się, że prawidłowo wybraliśmy kluczowe elementy z twojego produktowego feedu. Służą one temu, aby na obrazach pojawiały się poprawne informacje, takie jak cena, nazwa, marka czy dostępność.",
			"steps_need_inspiration_perex": "Sprawdź te edytowalne szablony, które dla ciebie przygotowaliśmy.",
			"steps_need_inspiration": "Potrzebujesz inspiracji?",
			"first_steps_title": "Przewodnik pierwszej konfiguracji",
			"steps_third": "Zostanmy w kontakcie",
			"steps_third_subscribe": "Zapisuję się również do newslettera",
			"create_first_template": "Utwórz pierwszy szablon",
			"steps_create_blank": "Dodaj grafikę i CTA",
			"steps_create_resize": "Zmniejsz do określonego formatu",
			"steps_create_upscale": "Popraw jakość",
			"steps_create_bg_removal": "Usuń tło",
			"steps_create_watermarks": "Usuń znak wodny",
			"steps_create_header": "Gotowe! Możesz zaczynać tworzyć",
			"steps_create_perex": "Wszystko jest przygotowane. Teraz możesz zacząć edytować swoje zdjęcia produktowe i tworzyć pierwsze szablony.",
			"steps_who_are_you_title": "Abyśmy mogli polecić Państwu odpowiednie funkcje i ustawienia, prosimy, powiedzcie nam, kim jesteście.",
			"steps_who_are_you_subtitle": "Dzięki temu skonfigurujemy usługi dokładnie na miarę.",
			"steps_categorization_title": "Jaki typ e-sklepu prowadzisz?",
			"steps_categorization": "Wybierz kategorię, która najlepiej odpowiada Twojemu asortymentowi. Dzięki Twojej odpowiedzi dostarczymy ci lepiej dopasowane, spersonalizowane usługi.",
			"steps_third_email": "Twój adres e-mailowy",
			"steps_third_sublabel": "Będziemy wysyłać Ci powiadomienia systemowe, gdy tylko wydarzy się coś ważnego.",
			"steps_second": "Ustawienia wyjściowe",
			"output_image_format_sublabel": "Wybierz format wyjściowy obrazów.",
			"output_image_compression_sublabel": "Ustawienie poziomu jakości kompresji.",
			"auto_compression_to_size_sublabel": "Redukcja rozmiaru danych",
			"steps_third_email_sublabel": "Będziemy wysyłać powiadomienia, gdy zajdzie coś ważnego.",
			"visual_similarity": "Podobieństwo wizualne",
			"ai_params": "Dodawanie parametrów do produktów",
			"ai_params_generate": "Generuj parametry z obrazów do kanału",
			"ai_params_is_running_on_background": "Analiza obrazu AI i generowanie parametrów odbywają się w tle",
			"similar_images": "podobne obrazy",
			"find_similar_images": "Znajdź podobne obrazy",
			"searching_in_progress": "Trwa wyszukiwanie",
			"create_list_and_publish_to_visual_similarity": "Eksportuj obrazy w szablonie i znajdź podobne",
			"visual_similarity_last_update_at": "Funkcja podobieństwa wizualnego jest obecnie wyłączona. Wyniki są aktualne na dzień ",
			"image_cannot_be_downloaded": "Nie można pobrać obrazu",
			"product_has_no_image": "Produkt nie ma obrazu",
			"missing_image_element": "Brakuje elementu obrazu",
			"visual_similarity_enabled": "Znajdź podobne obrazy",
			"visual_similarity_n": "Liczba podobnych obrazów",
			"visual_similarity_threshold": "Indeks podobieństwa",
			"visual_similarity_search_products_in": "Szukaj podobnych w szablonach",
			"feature_enabled": "Funkcja jest włączona",
			"feature_disabled": "Funkcja jest wyłączona",
			"upload_images": "Przesyłać zdjęcia",
			"download_images": "Pobierz obrazy",
			"download_image": "Pobierz obraz",
			"upload_image": "Prześlij obraz",
			"uploaded_images": "Feltöltött képek",
			"external_image": "Elementy graficzne",
			"blog_link": "https://www.feed-image-editor.pl/blog",
			"please_select_templates": "Wybierz szablony, w których chcesz szukać podobnych produktów",
			"loading_results": "Ładowanie wyników",
			"exporting": "Eksportuję produkty",
			"task_queued": "Zadanie w kolejce",
			"waiting_before_publish": "Czekam z wysłaniem zadania",
			"popup_box_header": "Important Announcement. We are changing price for Feed Image Editor",
			"popup_box_body": "<p>Hello,<br/><br/>from <b>September 1, 2024</b>, we are adjusting the price for the Feed Image Editor application. The monthly fee without VAT will be 79 €. However, we have a special offer for you. If you are already our client with a monthly billing period and <b>switch to annual billing by July 31, 2024, you will have the application for the whole year at 38,4 € per month without VAT</b>. This offer also applies to new clients who will subscribe to the application for a year by July 31, 2024.</p><p>⇨ detailed scenarios for the transition to the new pricing can be found at <span class=\"link\" onClick=Mergado.openWindow(\"https://preview.mailerlite.io/preview/540026/emails/127294576066037196\")>this link</span></p><p>Additionally, annual billing will bring you a 20% discount on Mergado and all other applications from the Mergado Store. You have time until July 31, 2024 (inclusive).<br/><br/>Prices are per project.</p>",
			"understand": "Rozumiem",
			"rerender": "Przegenerować",
			"redownload": "Pobierz ponownie",
			"to_be_processed": "Pozostaje do przetworzenia",
			"similarity_less_than_n": "Nie udało się znaleźć wybranej liczby podobnych zdjęć dla danego produktu dla wybranej wartości wskaźnika podobieństwa. Rozważ zmniejszenie wartości wskaźnika podobieństwa.",
			"similarity_n_limit_info": "Ustaw liczbę podobnych zdjęć, które mają być wyszukiwane dla danego produktu. Niektóre produkty niekoniecznie muszą być wyszukiwane pod kątem tej liczby przy danej wartości wskaźnika podobieństwa. W takim przypadku należy rozważyć zmniejszenie wartości wskaźnika podobieństwa.",
			"similarity_threshold_info": "Indeks podobieństwa określa, w jaki sposób podobne obrazy mają być wyszukiwane pod kątem produktu. Im wyższa wartość, tym bardziej podobne obrazy. Wartość 1 spowoduje znalezienie dokładnie tych samych obrazów.",
			"fill_similarity_title": "Zapisywanie wyników do źródła wyjściowego",
			"fill_similarity_ids_element": "Identyfikatory produktów podobnych wizualnie",
			"fill_similarity_image_urls_element": "Adresy URL wizualnie podobnych obrazów",
			"no_items_filtered": "Nie znaleźliśmy żadnego wyboru",
			"no_match_with_element_regexp": "Element nie pasuje do filtra elementu aplikacji reguły (element_regex)",
			"advanced_settings": "Ustawienia zaawansowane",
			"mergado_max_payload_size": "Maksymalna liczba znaków wysyłanych w jednym żądaniu. Maksymalna możliwa wartość to 15 000 000 znaków.",
			"mergado_element_regex": "Wyrażenie regularne, według którego będą filtrowane elementy projektu",
			"mergado_xml_equivalent": "Elementy XML Mergado, których odpowiednik w danym formacie zostanie wysłany z Mergado.",
			"suggested_elements_to_be_excluded": "Sugerowane elementy, które możesz pominąć przy stosowaniu reguł",
			"alt_levels": "Alternatywne poziomy obrazów szablonów",
			"levels": "Poziomy aplikacji",
			"assigned_templates": "Przypisane szablony główne",
			"no_assigned_templates": "Brak przypisanych szablonów",
			"necessary": "Koniecznie",
			"exclude_some": "Pomiń wybrane",
			"regexp": "Wyrażenie regularne",
			"mergado_apply_elements": "Które elementy należy przesłać do FIE przy stosowaniu przepisów",
			"necessary_elements": "Elementy niezbędne do działania FIE",
			"selected_mergado_equivalent": "Wybrane odpowiedniki elementów Mergado",
			"categories": "Kategorie",
			"fashion": "Moda",
			"beauty": "Uroda",
			"health": "Zdrowie",
			"pets": "Zwierzęta domowe",
			"electronics": "Elektronika",
			"home_and_garden": "Dom i ogród",
			"kids": "Dzieci",
			"sports": "Lekkoatletyka",
			"books": "Książki",
			"cars": "Samochody",
			"services_and_experiences": "Usługi i doświadczenia",
			"other_category": "Inny",
			"back_to_original": "Zwróć tło",
			"paint_transparent": "Usuń tło",
			"waiting_for_product_to_be_loaded": "Oczekiwanie na załadowanie produktu",
			"should_rerender": "Należy ponownie renderować",
			"should_redownload": "Należy ponownie pobrać",
			"has_alt_images": "Ma alternatywne obrazy",
			"anim-gif": "Anim GIF",
			"auto-wmremove": "Usuń znaki wodne",
			"format_preset": "Przygotowany wcześniej",
			"format_original": "Oryginalny",
			"format_custom": "Niestandardowy",
			"turned_off": "wyłączony",
			"mode": "tryb",
			"inpainting_create_mask": "Zaznacz obszary, które zostaną zamalowane.",
			"inpainting_how_to_deal_with_diff_size": "Jak dostosować różne rozmiary masek i obrazów",
			"position_relative_to": "Pozycja względem",
			"scale_mask_to_image_size": "Skaluj maskę do rozmiaru obrazu",
			"scale_to_size": "Dostosuj rozmiar",
			"object_position": "Pozycja obiektu",
			"complex_background": "Złożone tło",
			"edit_element_content": "Edytuj zawartość elementu",
			"prefix": "tekst przed",
			"suffix": "tekst po",
			"decimals": "liczba miejsc",
			"separator": "separator",
			"replace": "zastępować",
			"find_as_regexp": "znajdź jako wyrażenie regularne",
			"symbol_table": "Specjalne symbole walutowe",
			"find_and_replace": "Znajdź i zamień",
			"add_text": "Wstaw tekst",
			"decimal_places": "Miejsca dziesiętne",
			"thousands_separation": "Oddziel tysiące",
			"short_url_with_extension": "Krótszy adres URL z rozszerzeniem pliku",
			"short_url_with_extension_info": "Krótsza forma adresu URL wyjściowego zawierająca rozszerzenie zgodnie z formatem obrazu wyjściowego. Niektóre testy porównawcze wymagają rozszerzenia obrazu w adresie.",
			"gradient_is_used_by_template": "Ten gradient jest używany przez szablon i nie można go usunąć.",
			"no_search_image_results": "Nie znaleziono obrazów odpowiadających wyszukiwanemu terminowi.",
			"import_from_project": "Importuj z projektu",
			"choose_project": "Wybierz projekt",
			"no_other_projects_of_user": "Brak projektów do zaimportowania.",
			"loading_queries": "Ładowanie selekcji z Mergado",
			"loading_template": "Ładowanie szablonu",
			"text_mode": "Tryb tekstowy",
			"total_icons": "Razem ikony",
			"try_icons": "Wypróbuj ikony",
			"icon_color": "Kolor ikony",
			"did_not_found_stickers": "Nie znalazłeś odpowiednich naklejek?",
			"ai_elements_to_feed": "Wzbogacanie paszy za pomocą sztucznej inteligencji",
			"mcp": "MCP",
            }
        }
    